import { render, staticRenderFns } from "./LavoriTipo.vue?vue&type=template&id=400a0a32&"
import script from "./LavoriTipo.vue?vue&type=script&lang=js&"
export * from "./LavoriTipo.vue?vue&type=script&lang=js&"
import style0 from "./LavoriTipo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports